import { TLang } from 'src/constants/langs'
import { LocalizedText } from 'src/types/common/localized'

import { TextContentRo, TextHeaderRo } from './ro/TextLandRo'
import { TextContentDe, TextHeaderDe } from './de/TextLandDe'
import { TextContentEs, TextHeaderEs } from './es/TextLandEs'
import { TextContentEn, TextHeaderEn } from './en/TextLandEn'
import { TextContentFr, TextHeaderFr } from './fr/TextLandFr'
import { TextContentIt, TextHeaderIt } from './it/TextLandIt'
import { TextContentPt, TextHeaderPt } from './pt/TextLandPt'
import { TextContentEl, TextHeaderEl } from './el/TextLandEl'
import { TextContentSl, TextHeaderSl } from './sl/TextLandSl'

export const texts: Record<TLang, LocalizedText<true>> = {
    en: { header: <TextHeaderEn />, content: <TextContentEn /> },
    de: { header: <TextHeaderDe />, content: <TextContentDe /> },
    ro: { header: <TextHeaderRo />, content: <TextContentRo /> },
    es: { header: <TextHeaderEs />, content: <TextContentEs /> },
    fr: { header: <TextHeaderFr />, content: <TextContentFr /> },
    it: { header: <TextHeaderIt />, content: <TextContentIt /> },
    pt: { header: <TextHeaderPt />, content: <TextContentPt /> },
    el: { header: <TextHeaderEl />, content: <TextContentEl /> },
    sl: { header: <TextHeaderSl />, content: <TextContentSl /> },
}
